var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgContent)?_c('i',{staticClass:"md-icon",domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):(_vm.imageSrc)?_c('img',{staticClass:"md-icon",attrs:{"src":_vm.imageSrc,"alt":""}}):_c('i',{staticClass:"md-icon",class:[_vm.mdIconset],attrs:{"aria-hidden":!!_vm.mdIconset}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }